"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatPrice = exports.default = void 0;
var _Text = _interopRequireDefault(require("../Text"));
var _index = _interopRequireDefault(require("./index.styled"));
var _jsxRuntime = require("react/jsx-runtime");
const formatPrice = function (_ref) {
  let {
    price,
    locale
  } = _ref;
  return Number.parseFloat(price).toLocaleString(...(Array.isArray(locale) ? locale : [locale]));
};
exports.formatPrice = formatPrice;
const PriceFormat = function (_ref2) {
  let {
    price = 0,
    withUsdCurrencySymbol = true,
    displayZero = false,
    locale = [undefined, {
      style: "decimal",
      currency: "USD",
      maximumFractionDigits: 2
    }],
    override = "",
    disclaimer = "",
    note = "",
    StyledPrice = _index.default.Price,
    StyledOverride = _index.default.Override,
    className = "",
    showDisclaimer = true
  } = _ref2;
  const WrappedStyling = override ? StyledOverride : StyledPrice;
  const formattedPrice = formatPrice({
    price,
    locale
  });
  const currencySymbol = withUsdCurrencySymbol ? "$" : "";
  const addedNote = note ? ` ${note}` : "";
  if (!override && price === 0 && !displayZero) {
    return null;
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(WrappedStyling, {
    className: className,
    "data-testid": "PriceFormat",
    children: [override || /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_index.default.Symbol, {
        children: currencySymbol
      }), formattedPrice, addedNote]
    }), showDisclaimer && disclaimer && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
      children: disclaimer
    })]
  });
};
var _default = exports.default = PriceFormat;